import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form'

import { Roles, User } from 'data'

import * as PlusUserActions from '../../store/plusUsers/actions'
import * as UserActions from '../../store/user/actions'
import Content from './content'

import './style.scss'

import { RouteComponentProps } from 'react-router'
import SnackbarService from '../../services/snackbars'

import { IMixpanelProps, IOnlineProps, withMixpanel } from 'components'

import { _route } from '../../routes/config'

interface ILoginForm {
  email: string
  password: string
}

interface IProps
  extends InjectedFormProps,
    RouteComponentProps,
    IMixpanelProps,
    IOnlineProps {
  loginForm: ILoginForm
  UserLib?: any
  PlusUserLib: any
  userData: any
}

interface IState {
  loading: boolean
}

class Login extends React.Component<IProps, IState> {
  state: IState = {
    loading: false
  }

  keyPressed = (e: KeyboardEvent) => {
    switch (e.keyCode) {
      case 13:
        this.enterPressed()
        break
      default:
        break
    }
  }

  enterPressed = () => this.doLogin()

  componentDidMount() {
    document.addEventListener('keydown', this.keyPressed)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keyPressed)
  }

  startLoading = () => {
    this.setState({ loading: true })
  }

  endLoading = () => {
    this.setState({ loading: false })
  }

  doLogin = () => {
    const {
      loginForm: { email, password },
      history,
      UserLib,
      PlusUserLib
      // online
    } = this.props

    this.startLoading()

    // if (!online) {
    //   SnackbarService.showSnackbar('Internet connection problem', 'error', true)
    // }

    UserLib.login(
      email,
      password,
      PlusUserLib,
      (user: User, isPlusUser: boolean) => {
        this.endLoading()
        if (isPlusUser) {
          if (user.role === Roles.CareProfessional) {
            history.push(`/patients_list`)
          }
          // commented this out because the route is already pushed to the stack
          // else if (user.role === Roles.Parent) {
          //   history.replace(`/children_list`,{ path: "login"})
          // }
        }
        // commented this out because the route is already pushed to the stack
        //  else {
        //   history.push(`/payment`)
        // }
      },
      (errorMessage: string) => {
        SnackbarService.showSnackbar(errorMessage, 'error')
        this.endLoading()
      }
    )
  }

  onForgot = () => {
    const { history } = this.props
    history.push(_route.password.forgot)
  }

  render() {
    const { loading } = this.state
    return (
      <Content
        doLogin={this.doLogin}
        onForgot={this.onForgot}
        loading={loading}
      />
    )
  }
}

const LoginContainer = reduxForm({
  form: 'login'
})(Login)

const selector = formValueSelector('login')

const mapStateToProps = state => {
  const loginForm = {
    email: selector(state, 'email') || '',
    password: selector(state, 'password') || ''
  }

  return {
    ...loginForm,
    loginForm
  }
}

const mapDispatchToProps = dispatch => {
  return {
    UserLib: bindActionCreators<any, any>(UserActions as any, dispatch),
    PlusUserLib: bindActionCreators<any, any>(PlusUserActions as any, dispatch)
  }
}

export default compose(
  withMixpanel,
  connect(mapStateToProps, mapDispatchToProps)
)(LoginContainer)



// WEBPACK FOOTER //
// ./src/pages/Login/index.tsx